<template>
    <clean-layout :pageTitle="Lang.get('employeedashboard::pages/auth/reset.title')">
        <div class="row">
            <div class="col-12 col-md-10 col-lg-7 mx-auto">
                <div class="card shadow border-0 border-radius-16">
                    <AuthTabPanel>
                        <AuthTabPane
                            :active="true"
                            id="employer"
                            aria-label="employee-tab"
                        >
                            <p class="font-poppins font-weight-light color-dark-blue">
                                {{ Lang.get('employeedashboard::pages/auth/reset.employer_tab.intro') }}
                            </p>
                            <form @submit.prevent="submit()">
                                <div class="form-group mt-4 mb-4">
                                    <label for="employerEmail" class="font-poppins color-dark-blue">{{
                                            Lang.get('employeedashboard::pages/auth/reset.employer_tab.labels.email')
                                        }}</label>
                                    <input type="email" class="form-control font-poppins" id="employerEmail"
                                           :value="this.email" readonly>
                                </div>
                                <div class="form-group mt-4">
                                    <label for="employerPassword" class="font-poppins w-100 color-dark-blue">{{
                                            Lang.get('employeedashboard::pages/auth/reset.employer_tab.labels.password')
                                        }}
                                        <a @click="showOrHidePasswordValue('password')">
                                                        <span class="float-right cursor-pointer link-show">
                                                            <img
                                                                :src="passwordType === 'password' ? '/img/login/icon-show.svg' : '/img/login/icon-hide.svg'">
                                                            {{
                                                                passwordType === 'password'
                                                                    ? Lang.get('employeedashboard::pages/auth/reset.labels.show')
                                                                    : Lang.get('employeedashboard::pages/auth/reset.labels.hide')
                                                            }}</span>
                                        </a>
                                    </label>
                                    <input
                                        v-model="form.password"
                                        :type="passwordType"
                                        class="form-control font-poppins password-check"
                                        id="employerPassword"
                                        :error="errors.password"
                                        :placeholder="Lang.get('employeedashboard::pages/auth/reset.employer_tab.labels.password_placeholder')">

                                    <div v-if="errors && Array.isArray(errors.password)" class="form-error">
                                        {{ errors.password.join(',') }}
                                    </div>
                                    <div v-if="errors && errors.password instanceof String" class="form-error">
                                        {{ errors.password }}
                                    </div>

                                    <password-validation :inputVal="form.password"/>

                                </div>
                                <div class="form-group mt-4 mb-5">
                                    <label for="employerPassword2" class="font-poppins w-100 color-dark-blue">
                                        {{
                                            Lang.get('employeedashboard::pages/auth/reset.employer_tab.labels.password_confirmation_placeholder')
                                        }}

                                        <a @click="showOrHidePasswordValue('passwordConfirm')">
                                                <span class="float-right cursor-pointer link-show">
                                                    <img
                                                        :src="passwordConfirmType === 'password' ? '/img/login/icon-show.svg' : '/img/login/icon-hide.svg'">
                                                    {{
                                                        passwordConfirmType === 'password'
                                                            ? Lang.get('employeedashboard::pages/auth/reset.labels.show')
                                                            : Lang.get('employeedashboard::pages/auth/reset.labels.hide')
                                                    }}
                                                </span>
                                        </a>
                                    </label>
                                    <input
                                        v-model="form.passwordConfirmation"
                                        :type="passwordConfirmType"
                                        class="form-control font-poppins"
                                        :class="passwordConfirmEqualsPassword ? 'is-valid' : ''"
                                        id="employerPassword2"
                                        :error="errors.password_confirmation"
                                        :placeholder="Lang.get('employeedashboard::pages/auth/reset.employer_tab.labels.password_confirmation_placeholder')">

                                    <div v-if="errors && Array.isArray(errors.password_confirmation)"
                                         class="form-error">
                                        {{ errors.password_confirmation.join(',') }}
                                    </div>
                                    <div v-if="errors && errors.password_confirmation instanceof String"
                                         class="form-error">
                                        {{ errors.password_confirmation }}
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    class="btn btn-primary btn-orange font-poppins font-weight-bold color-white border-radius-19 px-5">
                                    {{ Lang.get('employeedashboard::pages/auth/reset.button') }}
                                </button>
                            </form>
                        </AuthTabPane>

                        <AuthTabPane
                            id="employee"
                            aria-label="employee-tab"
                        >
                            <div class="tab-pane fade px-4 py-4" id="employee" role="tabpanel"
                                 aria-labelledby="employee-tab">
                                <p class="font-poppins font-weight-light color-dark-blue">
                                    {{ Lang.get('employeedashboard::pages/auth/reset.employee_tab.intro') }}
                                </p>
                                <form>
                                    <div class="form-group mt-4 mb-4">
                                        <label for="employeeEmail" class="font-poppins color-dark-blue">
                                            {{
                                                Lang.get('employeedashboard::pages/auth/reset.employee_tab.labels.email')
                                            }}
                                        </label>
                                        <input type="email" class="form-control font-poppins" id="employeeEmail"
                                               value="l***.***ben@*******ers.com"
                                               :placeholder="Lang.get('employeedashboard::pages/auth/reset.employee_tab.labels.email_placeholder')"
                                               readonly>
                                    </div>
                                    <button type="submit"
                                            class="btn btn-primary btn-orange font-poppins font-weight-bold color-white border-radius-19 px-5">
                                        {{ Lang.get('employeedashboard::pages/auth/reset.button') }}
                                    </button>
                                </form>
                            </div>
                        </AuthTabPane>
                    </AuthTabPanel>
                </div>
            </div>
        </div>
    </clean-layout>
</template>

<script>
import CleanLayout from '@/Shared/CleanLayout'
import TextInput from "@/Shared/TextInput";
import throttle from "lodash/throttle";
import PasswordValidation from "@/Shared/PasswordValidation.vue";
import AuthTabPane from "./AuthTabPane";
import AuthTabPanel from "./AuthTabPanel";

export default {
    metaInfo: {title: Lang.get('employeedashboard::pages/auth/reset.title')},
    components: {
        AuthTabPanel,
        AuthTabPane,
        TextInput,
        CleanLayout,
        PasswordValidation
    },
    props: {
        errors: Object,
        token: String,
        email: String,
    },
    data() {
        return {
            passwordType: 'password',
            passwordConfirmType: 'password',
            passwordConfirmEqualsPassword: false,
            form: {
                password: null,
                passwordConfirmation: null,
            },
        }
    },
    methods: {
        submit() {
            this.$inertia.post(
                this.route(`${this.$page.props.locale}.employeedashboard.reset.password.attempt`),
                {
                    email: this.email,
                    token: this.token,
                    password: this.form.password,
                    password_confirmation: this.form.passwordConfirmation,
                }
            );
        },

        showOrHidePasswordValue(input) {
            switch (input) {
                case 'password':
                    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
                    break;
                case 'passwordConfirm':
                    this.passwordConfirmType = this.passwordConfirmType === 'password' ? 'text' : 'password';
                    break;
            }
        },

    },
    watch: {
        form: {
            handler: throttle(function () {

                this.passwordConfirmEqualsPassword = this.form.password === this.form.passwordConfirmation;

            }, 150),
            deep: true,
        },
    },
}
</script>
